import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import firebase from '../config/database';
import Config from   '../config/app';
import Input from '../components/fields/Input.js';
import SkyLight from 'react-skylight';
import INSERT_STRUCTURE from "../config/schema.json";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


toast.configure({
    autoClose: 3000,
    draggable: false
});

export default class AddItemDialog extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            itemTitleToAdd: 'Title',
            itemTypeToAdd: 'image',
            notifications:[],
            count:''
            
        }
       
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.addFolderItem = this.addFolderItem.bind(this);
        //this.refreshDataAndHideNotification = this.refreshDataAndHideNotification.bind(this);
        this.sendData = this.sendData.bind(this);
    }
    
    componentDidUpdate(prevProps){
        if(prevProps.show !== this.props.show || prevProps.makeNewRequest !== this.props.makeNewRequest){
            if(this.props.show){
                this.refs.selectFolderItem.show();
            }
            else{
                this.props.refreshDataAndHideNotification();
                
            }
        }
      
    }

    sendData(notification){
        this.props.notifyCallback(notification);
        
   }
   
  

    handleTypeChange(e){
        this.setState({ itemTypeToAdd: e.target.value });
        console.log(e.target.value);
        console.log(this.state.itemTypeToAdd);
       
    }

    handleTitleChange(key, value){
        if (key == 'TITLE_OF_THE_NEW_ITEM') {
            this.setState({ itemTitleToAdd: value });
        }
        console.log(this.state.itemTitleToAdd);
    }
    notify(){
        toast.success("Success: Data is added successfully !!", {
            position: toast.POSITION.TOP_CENTER
          });
    }

    addToNavigation(path,name){
        var title=  name.replace(/^./, name[0].toUpperCase()); 
        var navTitle = path.substring(11);
        
        //firebase.app.database().ref('navigation/').set(correctPathToInsertIn);
        // Get a key for a new navigation
        // var newNavigationKey = firebase.app.database().ref('navigation/').push().key;
        // console.log(newNavigationKey);
        var item ={
            name:title,
            icon:'transform',
            link:'fireadmin',
            path:path,
            tableFields:['title','description','type']
        }
        
        firebase.app.database().ref(`navigation/${navTitle}`).set(item);
        

        // Write the new navigation data simultaneously in the navigation list
         //firebase.app.database().ref(`navigation/${newNavigationKey}`).set(item); 
          //firebase.app.database().ref('navigation/').push().set(item);
    }
    
    addFolderItem(){
        var name = "item";
        var howLongItIs = this.props.howlongitis;
        var dataToInsert = null;
        var correctPathToInsertIn="";
        var index ='';
         
           switch(this.state.itemTypeToAdd){
             case "image":
                 index=0;
               break;
   
             case "video":
                 index= 1;
               break;
             
             case "audio":
                index= 2;
              break;
   
             case "pdf":
                 index=3;
               break;
   
               case "folder":
                 index=4;
               break;  
             }
         
         
         console.log(index);
         console.log(howLongItIs);
         console.log(INSERT_STRUCTURE)
         dataToInsert=INSERT_STRUCTURE.mySection[name];
         dataToInsert[index].title=this.state.itemTitleToAdd;
         dataToInsert=dataToInsert?dataToInsert[index]:null;
         if(howLongItIs>0){
             console.log(this.props.firebasePath);
             correctPathToInsertIn=this.props.firebasePath+"/"+name+"/"+(parseInt(howLongItIs));
             ReactDOM.findDOMNode(this).scrollIntoView(); 
        }else{
            correctPathToInsertIn=`newSection_${new Date().getTime()}/`;
            dataToInsert= {...dataToInsert,isPublished: false}
            this.addToNavigation(correctPathToInsertIn.slice(0,-1),this.state.itemTitleToAdd);
            ReactDOM.findDOMNode(this).scrollIntoView();
         
   
        }
         
         if(dataToInsert!=null){
   
             console.log("Save path: "+correctPathToInsertIn);
                 firebase.app.database().ref(correctPathToInsertIn).set(dataToInsert).then(()=>{
                     if(this.props.count){
                         this.notify();
                     }else{
                         this.sendData({type:"success",content:"Item is inserted."})
                     }
                     
   
                     if(Config.adminConfig.goDirectlyInTheInsertedNode){
                       console.log("redirect to new page "+(parseInt(howLongItIs)));
                      this.props.router.push(this.props.route.path.replace(":sub","")+(this.props.params&&this.props.params.sub?this.props.params.sub:"")+Config.adminConfig.urlSeparator+(parseInt(howLongItIs)));
                     }
                     this.refs.selectFolderItem.hide()
                     this.props.refreshDataAndHideNotification();
                     this.setState({
                         itemTitleToAdd:'Title',
                         itemTypeToAdd:'image'
                     })
   
                 });
   
         }else{
             this.sendData({type:"danger",content:"Error 201: We are missing correct insert schema."})
             
         }

         
      }
   
  
        
    
    render() {
        
        var addItemModal = {
            backgroundColor: '#ffffff',
            marginTop: '40%',
            marginLeft: '-25%',
            
        };
        var customStyle ={
            position:'absolute',
            marginTop: '55%',
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(0,0,0,0.3)'
          }
        var addSectionModal = {
            backgroundColor: '#ffffff',
            marginLeft: '-25%',
        };
        if(this.props.howlongitis > 0){

            return (
                <SkyLight dialogStyles={addItemModal} overlayStyles={customStyle} hideOnOverlayClicked ref="selectFolderItem" title="">
                    <span><h3 className="center-block">Select Item to Add</h3></span>
                        <br />
                        <div className="card-content">
                            <div className="row">
                                <label className="col-sm-3 label-on-left">Title</label>
                                <div className="col-sm-12">
                                    <Input updateAction={this.handleTitleChange} class="" theKey="TITLE_OF_THE_NEW_ITEM" value={this.state.itemTitleToAdd} />
                                </div>
                                <div className="col-sm-1">
                                </div>
                            </div>
                        </div><br /><br />
                        <div className="card-content">
                            <div className="row">
                                <label className="col-sm-3 label-on-left">Type</label>
                                <div className="col-sm-12">
                                    <select onChange={this.handleTypeChange} value={this.state.itemTypeToAdd} >
                                        <option value="image">Image</option>
                                        <option value="video">Video</option>
                                        <option value="audio">Audio</option>
                                        <option value="pdf">Pdf</option>
                                        <option value="folder">Folder</option>
                                    </select>
                                </div>
                                <div className="col-sm-1">
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 ">
                            <div className="col-sm-3 ">
                            </div>
                            <div className="col-sm-6 center-block">
                                <a onClick={this.addFolderItem} className="btn btn-rose btn-round center-block"><i className="fa fa-save"></i>Add Item</a>
                            </div>
                            <div className="col-sm-3 ">
                            </div>
                        </div>
                    </SkyLight>
            )
        }else{
            return(
             <SkyLight dialogStyles={addSectionModal}  hideOnOverlayClicked ref="selectFolderItem" title="">
                    <span><h3 className="center-block">Add New Section</h3></span>
                        <br />
                        <div className="card-content">
                            <div className="row">
                                <label className="col-sm-3 label-on-left">Title</label>
                                <div className="col-sm-12">
                                    <Input 
                                    updateAction={this.handleTitleChange} 
                                    class="" theKey="TITLE_OF_THE_NEW_ITEM" 
                                    value={this.state.itemTitleToAdd} 
                                    placeholder="Title"/>
                                </div>
                                <div className="col-sm-1">
                                </div>
                            </div>
                        </div><br /><br />
                        <div className="card-content">
                            <div className="row">
                                <label className="col-sm-3 label-on-left">Type</label>
                                <div className="col-sm-12">
                                    <select onChange={this.handleTypeChange} value={this.state.itemTypeToAdd} >
                                        <option value="image">Image</option>
                                        <option value="video">Video</option>
                                        <option value="audio">Audio</option>
                                        <option value="pdf">Pdf</option>
                                        <option value="folder">Folder</option>
                                    </select>
                                </div>
                                <div className="col-sm-1">
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 ">
                            <div className="col-sm-3 ">
                            </div>
                            <div className="col-sm-6 center-block">
                                <a onClick={this.addFolderItem} className="btn btn-rose btn-round center-block"><i className="fa fa-save"></i>Add Item</a>
                            </div>
                            <div className="col-sm-3 ">
                            </div>
                        </div>
                    </SkyLight>
            )


        }

        
    }
}



// WEBPACK FOOTER //
// ./src/components/AddItemDialog.js